import { render, staticRenderFns } from "./IconAdministracion.vue?vue&type=template&id=3967fac7"
import script from "./IconAdministracion.vue?vue&type=script&lang=ts"
export * from "./IconAdministracion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports